import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { Dialog, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { DatePickerComponent, TimePickerComponent } from '@syncfusion/ej2-react-calendars';
import React, { useState, useEffect } from 'react';
import { Button, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useGetDriversForTransferOptionsQuery, useGetOrderTransferOptionsQuery, useSaveOrderTransferOptionsMutation } from '../../../features/Dispatch/TripDispatchSlice';
import { Typeahead } from 'react-bootstrap-typeahead';
import { Menu, MenuItem } from 'react-bootstrap-typeahead';
import errorHandler from '../../hooks/ErrorHanlder';
import swal from 'sweetalert';

const TransferDelivery = (props) => {
    const [readyDate, setReadyDate] = useState(new Date().toISOString().split('T')[0]);
    const [readyTime, setReadyTime] = useState(new Date().toLocaleTimeString('en-GB').slice(0, 5));
    const [notes, setNotes] = useState('');
    const [selectedOption, setSelectedOption] = useState("6");
    const [selectedDock, setSelectedDock] = useState('');
    const [dockDriver, setDockDriver] = useState(null);
    const { data: orderTransferOptions } = useGetOrderTransferOptionsQuery();
    const [saveOrderTransferOptions] = useSaveOrderTransferOptionsMutation();
    const { data: driversForTransferOptions } = useGetDriversForTransferOptionsQuery();
    const docks = driversForTransferOptions?.data?.find(driver => driver.driverNumber == dockDriver)?.docks || [];
    const isDivision = driversForTransferOptions?.data?.find(driver => driver.driverNumber == dockDriver)?.type === 'Interdivision';
    const [selectedService, setSelectedService] = useState(null);
    const [selectedVehicle, setSelectedVehicle] = useState(null);

    const statusMap = {
        'O': 'Open',
        'L': 'Loading',
        'OUT': 'Outbound',
        'IN': 'Inbound',
        'C': 'Completed',
    }

    useEffect(() => {
        if (props.showDeliveryTransfer) {
            setReadyDate(new Date().toISOString().split('T')[0]);
            setReadyTime(new Date().toLocaleTimeString('en-GB').slice(0, 5));
            setNotes('');
            setSelectedOption("6");
            setSelectedDock('');
            setDockDriver(null);
            setSelectedVehicle(null);
            setSelectedService(null);
        }
    }, [props.showDeliveryTransfer]);

    const handleTransmit = async () => {
        if (props.selectedDriverForTransfer?.type === 'Interdivision') {
            if (!selectedVehicle) {
                toast.error('Please select a vehicle', { position: 'top-center' });
                return;
            }
            if (!selectedService) {
                toast.error('Please select a service', { position: 'top-center' });
                return;
            }
        }
        if (selectedOption === "10" && !dockDriver) {
            toast.error('Please select a dock driver', { position: 'top-center' });
            return;
        }
        if (selectedOption === "10" && isDivision && !selectedDock) {
            toast.error('Please select a dock', { position: 'top-center' });
            return;
        }
        const transmitData = {
            divisionId: props.divisionId,
            selectedTransferOptionId: selectedOption,
            orderNumber: props.orderNumber,
            orderID: props.orderID,
            isAtPickupSide: false,
            driverNumber: props.selectedDriverForTransfer?.driverNumber,
            driverType: props.selectedDriverForTransfer?.type,
            dockDriver: dockDriver || props.selectedDriverForTransfer?.driverNumber,
            interdivisionDock: selectedDock || null,
            date: readyDate,
            time: readyTime,
            notesSection: notes,
            serviceID: selectedService,
            vehicleID: selectedVehicle,
        }
        try {
            const response = await saveOrderTransferOptions(transmitData).unwrap();
            props.setShowDeliveryTransfer(false)
            swal({title: "Success", text: response.message, icon: "success", button: "OK",});
            props.getAllOpenTripOrders(props.divisionId);
            if (props.selectedTrip) {
                props.getTripOrdersClassification({ tripStatus: statusMap[props.selectedTrip?.tripStatusCode], tripId: props.selectedTrip?.tripID, divisionId: props.divisionId });
            }
            setNotes('');
        } catch (error) {
            errorHandler(error);
        }
    };

    return (
        <Dialog open={props.showDeliveryTransfer} onClose={() => props.setShowDeliveryTransfer(false)} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" >
            <DialogTitle id="alert-dialog-title" style={{ backgroundColor: '#bf2527', color: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                Enter ready date and instructions
                <CloseRoundedIcon onClick={() => props.setShowDeliveryTransfer(false)} />
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <div className='mb-3 mt-3'>
                        <div style={{ color: '#244da1', fontWeight: 'bold' }} >Select an option to transmit order {props.orderNumber}:</div>
                        {/* <span style={{ color: '#bf2527', }}>Driver must be selected before using special instructions</span> */}
                    </div>
                    { props.selectedDriverForTransfer?.type === 'Interdivision' &&
                        <div className='d-flex mb-3 gap-2'>
                            <div className='w-100'>
                                <span>Select Vehicle:</span>
                                <Form.Select
                                    aria-label="Select Vehicle"
                                    onChange={(e) => setSelectedVehicle(e.target.value)}
                                    value={selectedVehicle}
                                >
                                    <option value=''>Select Vehicle</option>
                                    {props.vehiclesByDivision?.data?.map((vehicle) => (
                                        <option key={vehicle.vehicleId} value={vehicle.vehicleId}>{vehicle.vehicleType}</option>
                                    ))}
                                </Form.Select>
                            </div>
                            <div className='w-100'>
                                <span>Select Service:</span>
                                <Form.Select
                                    aria-label="Select Service"
                                    onChange={(e) => setSelectedService(e.target.value)}
                                    value={selectedService}
                                >
                                    <option value=''>Select Service</option>
                                    {props.servicesByDivision?.data?.map((service) => (
                                        <option key={service.serviceID} value={service.serviceID}>{service.service}</option>
                                    ))}
                                </Form.Select>
                            </div>
                        </div>
                    }
                    <div className='d-flex mb-3 gap-2'>
                        <div className='w-100'>
                            <span>Ready Date:</span>
                            <DatePickerComponent
                                value={readyDate}
                                placeholder="Select a date"
                                change={(e) => setReadyDate(e.target.value)}
                                format="MM/dd/yyyy"
                            />
                        </div>
                        <div className='w-100' >
                            <span>Ready Date:</span>
                            <div className="timepicker">
                                <TimePickerComponent id="time" placeholder="Open time" name="OfficeHour" className='input' value={readyTime} format={'hh:mm a'} />
                            </div>
                        </div>
                    </div>
                    {orderTransferOptions?.data?.filter(option => option.type === 'D' && option.id !== 10).map((option) => (
                        <div key={option.id} className='d-flex gap-2 pb-2'>
                            <input
                                style={{ transform: 'scale(1.3)', cursor: 'pointer' }}
                                type="radio"
                                name="options"
                                value={String(option.id)}
                                checked={selectedOption === String(option.id)}
                                onChange={(e) => {
                                    setDockDriver(null);
                                    setSelectedDock('');
                                    setSelectedOption(e.target.value)
                                }}
                                disabled={option.id === 9 && props.selectedDriverForTransfer?.type !== 'Interdivision'}
                            />
                            {option.transferOption}
                        </div>
                    ))}
                    <div className='d-flex align-items-start justify-content-between gap-2 '>
                        <div >
                            <input
                                style={{ transform: 'scale(1.3)', cursor: 'pointer', marginRight: '10px' }}
                                type="radio"
                                name="options"
                                id='10'
                                value="10"
                                checked={selectedOption === "10"}
                                onChange={(e) => setSelectedOption(e.target.value)}
                            />
                            <span style={{ marginRight: '10px' }}>Pickup from Shipper and return to dock</span>
                        </div>
                        <Typeahead
                            disabled={selectedOption !== "10"}
                            id="basic-typeahead-single"
                            labelKey={(option) => `${option.driverNumber} - ${option.type}`}
                            onChange={(selected) => {
                                if (selected.length > 0) {
                                    setDockDriver(selected[0].driverNumber);
                                } else {
                                    setDockDriver(null);
                                }
                            }}
                            options={driversForTransferOptions?.data?.filter(driver => driver.type !== 'Employee')}
                            placeholder="Select Agent/Interliner/Division"
                            selected={
                                dockDriver
                                    ? [
                                        driversForTransferOptions?.data?.find(
                                            driver => driver.driverNumber === dockDriver
                                        )
                                    ]
                                    : []
                            }
                            positionFixed={false}
                            renderMenu={(results, menuProps) => (
                                <Menu {...menuProps} style={{ maxHeight: '120px', overflowY: 'auto', zIndex: 1500 }}>
                                    {results.map((result, index) => (
                                        <MenuItem option={result} position={index} key={index}>
                                            {`${result.driverNumber} (${result.type})`}
                                        </MenuItem>
                                    ))}
                                </Menu>
                            )}
                        />
                        {isDivision &&
                            <Form.Select
                                aria-label="Floating label select example"
                                style={{ "width": '30%' }}
                                onChange={(e) => setSelectedDock(e.target.value)}
                                disabled={selectedOption !== "10"}
                                value={selectedDock}
                            >
                                <option value='0'>Select Dock</option>
                                {docks.map((dock) => (
                                    <option key={dock.dockID} value={dock.dockID}>{dock.dockName}</option>
                                ))}
                            </Form.Select>
                        }
                    </div>
                    <textarea
                        className='transferNotes'
                        value={notes}
                        onChange={(e) => setNotes(e.target.value)}
                        placeholder="Notes..."
                        style={{ width: '100%', height: '80px' }}
                    />
                    <div className='mt-2 d-flex justify-content-end'>
                        <Button className="btn-primary w-25" onClick={handleTransmit} autoFocus> Transmit</Button>
                    </div>
                </DialogContentText>
            </DialogContent>
        </Dialog>
    );
};

export default TransferDelivery;